'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ESForm = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translate = require('@esnpm/translate');

var _reactRedux = require('react-redux');

var _trESForms = require('../translations/trESForms');

var _ButtonGroup = require('./ButtonGroup');

var _City = require('./City');

var _Company = require('./Company');

var _Country = require('./Country');

var _CustomerType = require('./CustomerType');

var _Email = require('./Email');

var _Field = require('./Field');

var _Firstname = require('./Firstname');

var _LanguageText = require('./LanguageText');

var _Name = require('./Name');

var _Lastname = require('./Lastname');

var _Newsletter = require('./Newsletter');

var _Password = require('./Password');

var _PasswordRepeat = require('./PasswordRepeat');

var _Phone = require('./Phone');

var _Select = require('./Select');

var _Street = require('./Street');

var _Text = require('./Text');

var _Toggle = require('./Toggle');

var _VatId = require('./VatId');

var _Zipcode = require('./Zipcode');

var _Number = require('./Number');

var _Price = require('./Price');

var _SKU = require('./SKU');

var _Comment = require('./Comment');

var _Break = require('./Break');

var _Translation = require('./Translation');

var _CapitalText = require('./CapitalText');

var _Order = require('./Order');

var _Hidden = require('./Hidden');

var _Amount = require('./Amount');

var _SelectDepartment = require('./SelectDepartment');

var _SelectSupportReason = require('./SelectSupportReason');

var _Department = require('./Department');

var _InputButtonGroupNumber = require('./InputButtonGroupNumber');

var _InputButtonGroupText = require('./InputButtonGroupText');

var _GTCToggle = require('./GTCToggle');

var _InputButtonGroupEmail = require('./InputButtonGroupEmail');

var _InputButtonGroupSelect = require('./InputButtonGroupSelect');

var _CountryOfOrigin = require('./CountryOfOrigin');

var _Weight = require('./Weight');

var _LockableNumber = require('./LockableNumber');

var _LockableText = require('./LockableText');

var _ESFormContext = require('./ESFormContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classnames = require("classnames");

var ESForm = exports.ESForm = (_dec = (0, _reactRedux.connect)(null, null, null, { withRef: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
	_inherits(ESForm, _React$Component);

	function ESForm(props) {
		_classCallCheck(this, ESForm);

		var _this = _possibleConstructorReturn(this, (ESForm.__proto__ || Object.getPrototypeOf(ESForm)).call(this, props));

		_this.fields = {};

		_this.state = {
			valid: _this.isValid(),
			focus: ""
		};
		return _this;
	}

	_createClass(ESForm, [{
		key: 'registerField',
		value: function registerField(field) {
			// console.log('register', field.props.fieldName, field.props);
			this.fields[field.props.fieldName] = field;
			this.valid = this.isValid();
		}
	}, {
		key: 'unRegisterField',
		value: function unRegisterField(field) {
			// console.log('unregister', field.props.fieldName);
			delete this.fields[field.props.fieldName];
			this.valid = this.isValid();
		}
	}, {
		key: 'setFocus',
		value: function setFocus(fieldName) {
			this.setState({
				focus: fieldName
			});
		}
	}, {
		key: 'focus',
		value: function focus(fieldName) {
			// console.log("ESForm focus "+ fieldName)
			this.fields[fieldName].input.focus();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setState({ valid: this.isValid() });
			this.props.onValidChange(this.valid);
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			return { esForm: this };
		}

		//wird auch von aussen bei neuanmeldung eines feldes aufgerufen
		//dabei wirft der der console.log wegen dem Zugriff auf props ein Fehler

	}, {
		key: 'handleFieldValidChange',
		value: function handleFieldValidChange(field, fieldvalid) {
			var oldvalid = this.state.valid;
			var valid = this.isValid();

			// console.log("handlFieldValueChange", oldvalid, valid, field.props.fieldName, fieldvalid);

			if (oldvalid != valid) {

				this.setState({ valid: valid });
				this.props.onValidChange(valid);
			}
		}
	}, {
		key: 'value',
		value: function value() {
			var ret = {};
			Object.entries(this.fields).map(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    fieldName = _ref2[0],
				    field = _ref2[1];

				// console.log(fieldName,"  ", field.getValue())
				if (field.getValue() != null) {
					ret[fieldName] = field.getValue();
				}
			});
			return ret;
		}
	}, {
		key: 'isValid',
		value: function isValid() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = Object.values(this.fields)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var field = _step.value;

					// console.log(field.props.fieldName, field.state.valid);
					if (!field.state.valid) {
						return false;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return true;
		}
	}, {
		key: 'handleOnKeyDown',
		value: function handleOnKeyDown(e) {
			if (e.keyCode === 13) {
				if (this.isValid()) {
					this.props.onEnter();
				}
			}
		}
	}, {
		key: 'resetFields',
		value: function resetFields() {
			Object.entries(this.fields).map(function (_ref3) {
				var _ref4 = _slicedToArray(_ref3, 2),
				    fieldName = _ref4[0],
				    field = _ref4[1];

				field.setValFromExtern(field.props.optionalEmpty);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			if (this.props.form) {
				// const autocomplete = (this.props.autoComplete) ? "": "false";
				var contextData = {
					autoComplete: this.props.autoComplete
				};
				return _react2.default.createElement(
					_ESFormContext.ESFormContext.Provider,
					{ value: contextData },
					_react2.default.createElement(
						'form',
						{ onSubmit: this.handleSubmit },
						_react2.default.createElement(
							'table',
							{
								className: classnames("ESForm", { "horizontal": this.props.horizontal }),
								onKeyDown: function onKeyDown(e) {
									return _this2.handleOnKeyDown(e);
								}
							},
							_react2.default.createElement(
								'tbody',
								null,
								this.props.children
							)
						)
					)
				);
			} else {
				return _react2.default.createElement(
					'table',
					{
						className: classnames("ESForm", { "horizontal": this.props.horizontal }),
						onKeyDown: function onKeyDown(e) {
							return _this2.handleOnKeyDown(e);
						}
					},
					_react2.default.createElement(
						'tbody',
						null,
						this.props.children
					)
				);
			}
		}
	}, {
		key: 'handleSubmit',
		value: function handleSubmit(e) {
			e.preventDefault();
		}
	}]);

	return ESForm;
}(_react2.default.Component), _class2.childContextTypes = {
	esForm: _propTypes2.default.object
}, _class2.propTypes = {
	children: _propTypes2.default.any,
	name: _propTypes2.default.string,
	onValidChange: _propTypes2.default.func,
	noValidationClassChange: _propTypes2.default.bool,
	noValidationLabelClassChange: _propTypes2.default.bool,
	horizontal: _propTypes2.default.bool,
	classValid: _propTypes2.default.string,
	classInValid: _propTypes2.default.string,
	classHint: _propTypes2.default.string,
	onEnter: _propTypes2.default.func,
	form: _propTypes2.default.bool,
	autoComplete: _propTypes2.default.bool
}, _class2.defaultProps = {
	onValidChange: function onValidChange() {},
	noValidationClassChange: false,
	noValidationLabelClassChange: false,
	horizontal: false,
	classValid: 'Valid',
	classInValid: 'InValid',
	classHint: 'HintText',
	onEnter: function onEnter() {},
	form: false,
	autoComplete: false
}, _temp)) || _class);


ESForm.Field = _Field.Field;
ESForm.Break = _Break.Break;
ESForm.Text = _Text.Text;
ESForm.LanguageText = _LanguageText.LanguageText;
ESForm.Select = _Select.Select;
ESForm.ButtonGroup = _ButtonGroup.ButtonGroup;
ESForm.Name = _Name.Name;
ESForm.Firstname = _Firstname.Firstname;
ESForm.Lastname = _Lastname.Lastname;
ESForm.Department = _Department.Department;
ESForm.Country = _Country.Country;
ESForm.Company = _Company.Company;
ESForm.VatId = _VatId.VatId;
ESForm.Street = _Street.Street;
ESForm.City = _City.City;
ESForm.Zipcode = _Zipcode.Zipcode;
ESForm.Phone = _Phone.Phone;
ESForm.Email = _Email.Email;
ESForm.Password = _Password.Password;
ESForm.PasswordRepeat = _PasswordRepeat.PasswordRepeat;
ESForm.CustomerType = _CustomerType.CustomerType;
ESForm.Number = _Number.Number;
ESForm.Price = _Price.Price;
ESForm.SKU = _SKU.SKU;
ESForm.Comment = _Comment.Comment;
ESForm.Translation = _Translation.Translation;
ESForm.CapitalText = _CapitalText.CapitalText;
ESForm.Toggle = _Toggle.Toggle;
ESForm.Order = _Order.Order;
ESForm.Hidden = _Hidden.Hidden;
ESForm.Amount = _Amount.Amount;
ESForm.SelectDepartment = _SelectDepartment.SelectDepartment;
ESForm.SelectSupportReason = _SelectSupportReason.SelectSupportReason;
ESForm.InputButtonGroupNumber = _InputButtonGroupNumber.InputButtonGroupNumber;
ESForm.Newsletter = _Newsletter.Newsletter;
ESForm.InputButtonGroupText = _InputButtonGroupText.InputButtonGroupText;
ESForm.GTCToggle = _GTCToggle.GTCToggle;
ESForm.InputButtonGroupEmail = _InputButtonGroupEmail.InputButtonGroupEmail;
ESForm.InputButtonGroupSelect = _InputButtonGroupSelect.InputButtonGroupSelect;
ESForm.CountryOfOrigin = _CountryOfOrigin.CountryOfOrigin;
ESForm.Weight = _Weight.Weight;
ESForm.LockableNumber = _LockableNumber.LockableNumber;
ESForm.LockableText = _LockableText.LockableText;

ESForm.registerTranslation = function () {
	return (0, _translate.translation_register)('esforms', _trESForms.trESForms);
};